/**
 * Result shape of the corporate-group queries: the group is reached through its member client,
 * so every query wraps the group payload in a single-client connection.
 */
export interface CorporateGroupEnvelope<T> {
  clients: {
    edges: { node: { id: string; corporateGroup: T | null } }[];
  };
}

export function firstCorporateGroup<T>(data: CorporateGroupEnvelope<T> | undefined): T | undefined {
  return data?.clients.edges[0]?.node.corporateGroup ?? undefined;
}
